'use strict';

var nocUtil = require('../../util/noc-util');

module.exports = /*@ngInject*/ ["$scope", "$timeout", "$stateParams", "$filter", "ContentStatisticsFactory", "HighChartFactory", "TimeZoneFactory", function ($scope, $timeout, $stateParams, $filter, ContentStatisticsFactory, HighChartFactory, TimeZoneFactory) {
    $scope.synopsisData = {};
    $scope.registeredUserLoyaltyData = false;
    $scope.numberOfVistsPerContentData = false;
    $scope.percentageOfSessionVisitsPerContentData = false;
    $scope.deviceDistributionData = false;
    $scope.browserDistributionData = false;
    $scope.screenSizeDistributionData = false;

    //initial load
    $timeout(function () {
        $scope.reloadAll();
    }, 100);

    $scope.reloadAll = function () {
        var dayPeriod = nocUtil.beginAndEndOfDate(new Date());

        var tzPeriod  = TimeZoneFactory.formatPeriodInCurrentTimezone(dayPeriod.from, dayPeriod.to);

        var from = tzPeriod.start;
        var to = tzPeriod.end;

        var projectId = $stateParams.projectId;
        fetchSynopsis(projectId, from, to);
        fetchUserLoyalty(projectId, from, to);
        fetchContentVisitsNumber(projectId, from, to);
        fetchSessionVisitsPercentage(projectId, from, to);
        fetchDevicesDistribution(projectId, from, to);
        fetchBrowserDistribution(projectId, from, to);
        fetchScreenSizeDistribution(projectId, from, to);
    };
    function fetchSynopsis(projectId, from, to) {
        ContentStatisticsFactory.getSynopsis(projectId, from, to, function (data) {
            $scope.synopsis = data;
        });
    }
    function fetchUserLoyalty(projectId, from, to) {
        var chart = HighChartFactory.createBasicColumnChart("registeredUserLoyaltyDiv");
        var tooltip = {pointFormat: 'Users: <b>{point.y}</b>'};

        $scope.registeredUserLoyaltyData = false;
        ContentStatisticsFactory.getData("getUserLoyalty", projectId, from, to).then(function (data) {
            var serie = ContentStatisticsFactory.getColumnSerie(data, "User loyalty", true, tooltip);
            chart.addSeries(serie, false, false);
            chart.reflow();
            chart.redraw();
            $scope.registeredUserLoyaltyData = true;
        });
    }

    function fetchContentVisitsNumber(projectId, from, to) {
        var chart = HighChartFactory.createPieChart("numberOfVisitsPerContentDiv");
        chart.setTitle({text: ""}, null);
        chart.options.plotOptions.pie.dataLabels.enabled = true;
        var tooltip = {pointFormat: 'Visits: <b>{point.y}</b> ({point.percentage:.1f}%)'};

        $scope.numberOfVistsPerContentData = false;
        ContentStatisticsFactory.getData("getContentVisits", projectId, from, to).then(function (data) {
            data = ContentStatisticsFactory.nameValueToPieChartObjectTransformer(data);
            var serie = ContentStatisticsFactory.getPieSerie(data, "test", tooltip);
            chart.addSeries(serie, false, false);
            chart.reflow();
            chart.redraw();
            $scope.numberOfVistsPerContentData = true;
        });
    }
    function fetchSessionVisitsPercentage(projectId, from, to) {
        var chart = HighChartFactory.createBasicColumnChart("percentageOfSessionVistsPerContentDiv");
        var tooltip = {pointFormat: 'Visits: <b>{point.y}%</b>'};
        $scope.percentageOfSessionVisitsPerContentData = false;
        ContentStatisticsFactory.getData("getSessionVisits", projectId, from, to).then(function (data) {
            var serie = ContentStatisticsFactory.getColumnSerie(data, "Visits", false, tooltip);
            chart.addSeries(serie, false, false);
            chart.reflow();
            chart.redraw();
            $scope.percentageOfSessionVisitsPerContentData = true;
        });
    }
    function fetchDevicesDistribution(projectId, from, to) {
        var chart = HighChartFactory.createPieDonut("deviceDistributionDiv");

        $scope.deviceDistributionData = false;
        ContentStatisticsFactory.getData("getDevicesDist", projectId, from, to).then(function (data) {
            var groupedData = ContentStatisticsFactory.createDrillDownGroups(data);
            var series = ContentStatisticsFactory.getPieDonutSeries(groupedData[0], groupedData[1], "OS", "Version");
            var tooltip = {pointFormat: 'Count: <b>{point.y}</b> ({point.percentage:.1f}%)'};
            series[0].tooltip = tooltip;
            series[1].tooltip = tooltip;
            chart.addSeries(series[0], false, false);
            chart.addSeries(series[1], false, false);
            chart.reflow();
            chart.redraw();
            $scope.deviceDistributionData = true;
        });
    }
    function fetchBrowserDistribution(projectId, from, to) {
        var chart = HighChartFactory.createPieDonut("browserDistributionDiv");

        $scope.browserDistributionData = false;
        ContentStatisticsFactory.getData("getBrowserDist", projectId, from, to).then(function (data) {
            var groupedData = ContentStatisticsFactory.createDrillDownGroups(data);
            var series = ContentStatisticsFactory.getPieDonutSeries(groupedData[0], groupedData[1], "Browser", "Version");
            var tooltip = {pointFormat: 'Count: <b>{point.y}</b> ({point.percentage:.1f}%)'};
            series[0].tooltip = tooltip;
            series[1].tooltip = tooltip;
            chart.addSeries(series[0], false, false);
            chart.addSeries(series[1], false, false);
            chart.reflow();
            chart.redraw();
            $scope.browserDistributionData = true;
        });
    }
    function fetchScreenSizeDistribution(projectId, from, to) {
        var chart = HighChartFactory.createPieChart("screenSizeDistributionDiv");
        chart.setTitle({text: ""}, null);
        chart.options.plotOptions.pie.dataLabels.enabled = true;
        var tooltip = {pointFormat: 'Count: <b>{point.y}</b> ({point.percentage:.1f}%)'};

        ContentStatisticsFactory.getData("getScreenSize", projectId, from, to).then(function (data) {
            data = ContentStatisticsFactory.nameValueToPieChartObjectTransformer(data);
            var serie = ContentStatisticsFactory.getPieSerie(data, "test", tooltip);
            chart.addSeries(serie, false, false);
            chart.reflow();
            chart.redraw();
            $scope.screenSizeDistributionData = true;
        });
    }
}];
